import {useForm} from 'react-hook-form';
import {useEffect, useState} from 'react';
import {EyeIcon, EyeSlashIcon} from '@heroicons/react/24/outline';
import useSetDocumentTitle from 'hooks/useSetDocumentTitle';
import {Input} from '@/shadcn_components/ui/input';
import {Button} from '@/shadcn_components/ui/button';
import Spinner from '@/components/basic/Spinner';
import {useActiveAuthProvider, useIsAuthenticated, useLogin} from '@refinedev/core';
import background_image from '@/assets/background.png';
import logo from '@/assets/logo.svg';
import {useNavigate} from 'react-router';

const Login = () => {
  const authentication_check = useIsAuthenticated();
  const navigate = useNavigate();
  const authProvider = useActiveAuthProvider();

  const {
    mutate: login,
    error,
    isLoading,
  } = useLogin({
    v3LegacyAuthProviderCompatible: Boolean(authProvider?.isLegacy),
  });

  const [showPassword, setShowPassword] = useState(false);

  const {
    register,
    handleSubmit,
    formState: {errors},
    setValue,
  } = useForm();

  const onSubmit = async data => {
    await login(data);
  };

  useSetDocumentTitle('Đăng nhập');

  useEffect(() => {
    if (authentication_check.data?.authenticated) {
      navigate('/');
      // navigate('/app');
    }
  }, [authentication_check]);

  if (authentication_check.isFetching)
    return (
      <div className="flex flex-col items-center justify-center h-screen">
        <Spinner size={'xxl'} />
        <p className="mt-4 text-lg">Đang tải ...</p>
      </div>
    );

  return (
    <div
      className="relative flex flex-col justify-center h-screen overflow-hidden"
      style={{
        backgroundImage: `url(${background_image})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}>
      <div className="w-[90%] p-6  m-auto bg-white/80 rounded-3xl shadow-md lg:max-w-lg">
        <img src={logo} alt="logo" className="h-20 mx-auto my-4" />
        <h1 className="text-xl font-bold text-center text-[#262262] mb-8">
          BUILD TODAY, CREATE VALUE TOMORROW
        </h1>
        <form className="space-y-4" onSubmit={handleSubmit(onSubmit)}>
          <div>
            <label className="label">
              <span className="text-base font-medium label-text text-[#262262]">Tên đăng nhập</span>
            </label>
            <Input
              type="text"
              placeholder="Tên tài khoản"
              className="w-full bg-white"
              {...register('username', {required: 'Cần nhập tên đăng nhập'})}
            />
            <span className="mt-2 text-sm text-primary dark:text-red-500">
              {errors?.username?.message as string}
            </span>
          </div>
          <div>
            <label className="label">
              <span className="text-base font-medium label-text text-[#262262]">Mật khẩu</span>
            </label>
            <div className="relative flex items-center">
              <Input
                type={showPassword ? 'text' : 'password'}
                placeholder="Nhập mật khẩu"
                className="w-full bg-white pr-7"
                {...register('password', {required: 'Cần nhập mật khẩu'})}
              />
              {!showPassword ? (
                <EyeIcon
                  className="absolute right-2 w-5 h-5"
                  onClick={() => setShowPassword(!showPassword)}
                />
              ) : (
                <EyeSlashIcon
                  className="absolute right-2 w-5 h-5"
                  onClick={() => setShowPassword(!showPassword)}
                />
              )}
            </div>
            <span className="mt-2 text-sm text-primary dark:text-red-500">
              {errors?.password?.message as string}
            </span>
          </div>
          {/* <a href="#" className="text-xs text-gray-600 hover:underline hover:text-blue-600">
        Quên mật khẩu?
        </a> */}
          <div className="mt-2 text-sm text-primary dark:text-red-500">
            {error?.message as string}
          </div>
          <div>
            <Button
              type="submit"
              disabled={isLoading}
              className="w-full bg-gradient-to-r from-primary to-[#F7941D] hover:from-[#F7941D] hover:to-primary">
              {isLoading && <Spinner variant="destructive" size="sm" className="mr-2" />}Đăng nhập
            </Button>
          </div>

          {['entiz.kbtechdemo.com', 'entiz.localhost', 'localhost'].includes(location.hostname) && (
            <div className='flex space-x-2 justify-between'>
              <Button className='w-1/3'
                onClick={() => {
                  setValue('username', 'admin');
                  setValue('password', 'password');
                }}>
                Admin
              </Button>
              <Button className='w-1/3'
                onClick={() => {
                  setValue('username', 'staff_1');
                  setValue('password', 'password');
                }}>
                NV 1
              </Button>
              <Button className='w-1/3'
                onClick={() => {
                  setValue('username', 'staff_2');
                  setValue('password', 'password');
                }}>
                NV 2
              </Button>
            </div>
          )}
        </form>
      </div>
    </div>
  );
};

export default Login;
